import { Injectable } from '@angular/core';
import { Fetcher } from '../../http/fetcher';
import type { Team } from './team';

@Injectable({
    providedIn: 'root',
})
export class TeamFetcher extends Fetcher<Team> {
    readonly modelName = 'Team';

    get resourceName(): string {
        return 'teams';
    }
}
